<template>
  <v-app>
    <v-navigation-drawer
      fixed
      v-model="drawer"
      app
    >
      <v-list dense>
        <v-list-tile to="/">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/property/propertyList">
          <v-list-tile-action>
            <v-icon>work</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Property Management</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/rentalCalcList">
          <v-list-tile-action>
            <v-icon>assessment</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Rental Calculator</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>contact_mail</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Contact</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app dark flat color="primary" >
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title>
          <router-link to="/" class="toolbar-title">RentalAware</router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
          <v-btn v-if="isAuthenticated" flat>Hello, {{user.firstName}}</v-btn>
        <v-toolbar-items class="hid den-sm-and-down">
          <v-btn v-if="!isAuthenticated" to="/signup" flat>sign up</v-btn>
          <v-btn v-if="!isAuthenticated" to="/signin" flat>sign in</v-btn>
          <v-btn v-if="isAuthenticated" @click="userSignOut" flat>sign out</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-content>
        <v-container grid-list-sm fluid>
          <router-view></router-view>
        </v-container>
      </v-content>

      <v-footer dark flat>
        <v-layout row wrap>
          <v-flex >
        <v-card flat tile class="white--text text-xs-center">
          <v-card-text>
          © 2013-{{currentYear}} RentalAware, LLC. All Rights Reserved.
          </v-card-text>
        </v-card> 
        </v-flex>
        </v-layout>
      </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  },
  data () {
    return {
      drawer: null,
      currentYear: new Date().getFullYear()    
    }
  },
  methods: {
    userSignOut() {
      this.$store.dispatch("userSignOut");
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    user() {
      return this.$store.state.user;
    }
  }
}
</script>

<style>
.toolbar-title {
  color: white;
  font-weight: bold;
  font-size: larger;
  text-decoration: none;
}
</style>